const PREFIX = 'REGION/';

export const LIST_REGION = `${PREFIX}LIST`;
export const RETRIEVE_REGION = `${PREFIX}RETRIEVE`;

export const SET_REGION = `${PREFIX}SET_REGION`;
